












































































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import BerkasFormPanel from "@/components/pemeriksaan/berkasRm/BerkasFormPanel.vue";
import AjukanAksesRevisiDialog from "@/components/pemeriksaan/AjukanAksesRevisiDialog.vue";
import PersetujuanLayananDarahSvc from "@/services/PersetujuanLayananDarah";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";

@Component({ components: { BerkasFormPanel, AjukanAksesRevisiDialog } })
export default class BerkasPersetujuanDarah extends Vue {
  @Prop({ required: true }) readonly item!: any;
  @Prop({ required: true }) readonly register!: string | number;
  @Prop({ type: String, required: true }) readonly documentType!: string;
  @Prop({ type: String, required: true }) readonly category!: string;
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: Boolean, default: false }) readonly readOnly!: boolean;

  finalizing = false;

  get rmKey(): string {
    const rm = String(this.item.pasien_rm || "");
    return rm.length > 6 ? rm.slice(-6) : rm;
  }

  get jumlahBerkas(): number {
    return Number(this.item.berkas_count || 0);
  }

  get alasanTidakBisaFinal(): string {
    const userId = userModule.user ? userModule.user.id : null;
    if (String(this.item.creator_user_id) !== String(userId)) {
      return "Hanya petugas yang membuat persetujuan ini yang dapat memfinalisasi";
    }
    if (!this.jumlahBerkas) {
      return "Unggah scan lembar bertanda tangan basah terlebih dahulu";
    }
    return "";
  }

  waktu(val: string | null): string {
    return val ? moment(val).format("DD-MM-YYYY HH:mm") : "-";
  }

  onJumlahBerkas(jumlah: number) {
    if (Number(jumlah) !== this.jumlahBerkas) {
      this.$emit("jumlah-berkas", { id: this.item.id, jumlah: Number(jumlah) });
    }
  }

  bukaUpload() {
    const panel = this.$refs.berkasPanel as any;
    if (panel && panel.openUpload) panel.openUpload();
  }

  async finalisasi() {
    if (this.alasanTidakBisaFinal || this.finalizing) return;

    this.finalizing = true;
    try {
      const res = await PersetujuanLayananDarahSvc.finalisasi(this.category, this.item.id);
      appModule.NoticeDelay(res.message || "Persetujuan difinalisasi");
      this.$emit("changed");
    } catch {
      return;
    } finally {
      this.finalizing = false;
    }
  }
}
